/**
 * @desc pageList
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierSn.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSn/pageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
